// extracted by css-extract-rspack-plugin
export default {"QuestionPaneDetailLink":"hL0fl","QuestionPaneIcon":"jGAmw","description":"Hjxqm"};